import { z } from 'zod';
/**
 * Request Schema for Deleting a Tenant
 * Super-admin can delete a tenant
 */ export const DeleteTenantRequestSchema = z.object({
    tenantId: z.string()
});
/**
 * Response Schema for Deleting a Tenant
 */ export const DeleteTenantResponseSchema = z.object({
    success: z.boolean()
});

//# sourceMappingURL=delete-tenant.schema.js.map